import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/brand";

export default function FloatingWhatsapp() {
  return (
    <a
      data-testid="floating-whatsapp"
      href={BRAND.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40 group"
      aria-label="Contactar por WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
      <span className="relative inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#20BA57] text-white shadow-2xl shadow-emerald-900/30 transition-all hover:scale-110">
        <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7" />
      </span>
      <span className="hidden sm:block absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap px-3 py-2 rounded-lg bg-[#0B1528] text-white text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        ¡Habla con nosotros!
      </span>
    </a>
  );
}
